import axios from 'axios';
import {backendHost} from '../../config';

export const getTransactionsById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/transaction/${params.id}`);
};